// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client'; // For React 18+
import App from './App'; // Import the main App component

// Get the root DOM element where the React app will be mounted
const rootElement = document.getElementById('root');

// Create a root and render the App component into it
// This is the entry point of your React application
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("Root element with ID 'root' not found in the document.");
}